// Data type options for analytics filtering
export const DATA_TYPE_OPTIONS = [
  { label: 'All', value: undefined }, // No data_type parameter for "All"
  { label: 'Follow Up Calls', value: 'followup_calls' },
  { label: 'New Data Current Month', value: 'new_data_current_month' },
  { label: 'New Data Current Month Delivered', value: 'new_data_current_month_delivered' },
  { label: 'Previous Months Unreached Calls', value: 'previous_months_unreached_calls' },
  { label: 'Previous Months Pending Calls', value: 'previous_months_pending_calls' }
];

/**
 * Get the data_type value for a given label
 * @param {string} label - The data type label
 * @returns {string|undefined} The corresponding value
 */
export const getDataTypeValue = (label) => {
  const option = DATA_TYPE_OPTIONS.find(opt => opt.label === label);
  return option?.value;
};

/**
 * Generate query parameters with data type filtering
 * @param {Object} baseParams - Base parameters (year, month, etc.)
 * @param {string} selectedDataType - Selected data type label
 * @returns {Object} Query parameters with data_type array if needed
 */
export const generateQueryParams = (baseParams, selectedDataType) => {
  const params = { ...baseParams };
  const dataTypeValue = getDataTypeValue(selectedDataType);

  // Only add data_type if it's not "All"
  if (dataTypeValue) {
    params.data_type = [dataTypeValue]; // Backend expects array format
  }

  return params;
};
